var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgChat = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.115 4.115h16.923v12.693H5.353l-1.238 1.237V4.115Zm0-2.115a2.113 2.113 0 0 0-2.104 2.115L2 23.154l4.23-4.23h14.808a2.122 2.122 0 0 0 2.116-2.116V4.115A2.122 2.122 0 0 0 21.038 2H4.116Zm2.116 10.577h8.461v2.115H6.231v-2.115Zm0-3.173h12.692v2.115H6.231V9.404Zm0-3.173h12.692v2.115H6.231V6.231Z"
  })));
};
export { SvgChat as ReactComponent };